import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./AxiosInstance";

const initialState = {
  posts: [],
  status: "idle",
  error: null,
};

export const getData = createAsyncThunk(
  "posts/fetchPosts",
  async ({ url, FormDataDynamic }) => {
    try {
      const formData = new FormData();
      Object.keys(FormDataDynamic).forEach((key) => {
        formData.append(key, FormDataDynamic[key]);
      });

      // ✅ No Authorization header — cookie automatically bhej deta hai withCredentials se
      const response = await axiosInstance.post(url, formData, {
        headers: {
          Accept: "*/*",
        },
      });

      return response && response.data;
    } catch (error) {
      console.error("Error fetching posts:", error);
      throw error;
    }
  }
);

const getDataSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(getData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default getDataSlice.reducer;